import React from 'react';
import { Box, Text } from '@wix/design-system';
import s from './SocialProofHat.scss';

interface SocialProofHatProps {
  text: string;
  border?: string;
  borderTop?: string;
  borderBottom?: string;
  borderLeft?: string;
  borderRight?: string;
  borderRadius?: string;
  paddingY?: string;
}

const SparkleIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
  >
    <path d="M8.7392 3.95325C8.80091 3.67456 9.19822 3.67456 9.25993 3.95325L9.63755 5.65874C9.93641 7.00854 10.9906 8.06272 12.3404 8.36159L14.0459 8.7392C14.3246 8.80091 14.3246 9.19822 14.0459 9.25993L12.3404 9.63755C10.9906 9.93641 9.93641 10.9906 9.63755 12.3404L9.25993 14.0459C9.19822 14.3246 8.80091 14.3246 8.7392 14.0459L8.36159 12.3404C8.06272 10.9906 7.00854 9.93641 5.65874 9.63755L3.95325 9.25993C3.67456 9.19822 3.67456 8.80091 3.95325 8.7392L5.65874 8.36159C7.00854 8.06272 8.06272 7.00854 8.36159 5.65874L8.7392 3.95325Z" fill="var(--eclipse-text-color)"/>
  </svg>
);

export const SocialProofHat = ({
  text,
  border,
  borderTop,
  borderBottom,
  borderLeft,
  borderRight,
  borderRadius = '16px 16px 0 0',
  paddingY = 'SP2',
}: SocialProofHatProps) => (
  <Box
    width="100%"
    paddingTop={paddingY}
    paddingBottom={paddingY}
    paddingLeft="8px"
    paddingRight="8px"
    align="center"
    verticalAlign="middle"
    gap="1px"
    borderRadius={borderRadius}
    {...(border ? { border } : {})}
    boxSizing="border-box"
    style={{
      background: 'linear-gradient(to right, rgba(205,211,231,0.2) 11%, rgba(255,255,255,0.2) 33%, rgba(206,255,126,0.16) 57%, rgba(230,255,190,0.10) 73%), #F3F3F3',
      ...(borderTop ? { borderTop } : {}),
      ...(borderBottom !== undefined ? { borderBottom } : {}),
      ...(borderLeft ? { borderLeft } : {}),
      ...(borderRight ? { borderRight } : {}),
    }}
  >
    <SparkleIcon />
    <Text size="small" weight="bold" className={s.text}>
      {text}
    </Text>
  </Box>
);
